<script lang="ts" setup>
	/**
	 * Écran d'attente au démarrage.
	 *
	 * Couvre la résolution de la session et du mode : sans lui, un écran de borne
	 * afficherait fugitivement l'interface client avant de basculer.
	 */
	import MonacoLogo from '@/components/layout/MonacoLogo.vue';
</script>

<template>
	<div class="splash-screen">
		<MonacoLogo class="splash-screen_logo" />
		<v-progress-circular indeterminate color="primary" size="32" width="3" class="mt-8" />
	</div>
</template>

<style lang="scss">
	.splash-screen {
		position: fixed;
		inset: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background: rgb(var(--v-theme-background));
		z-index: 9999;

		&_logo {
			width: 220px;
			max-width: 60vw;
		}
	}
</style>
